<template>
  <div>
    <h3>分享给微信好友</h3>
    <div @click="initShare(0, 'wechat1')" class="test1">分享普通链接</div>
    <div @click="initShare(1, 'wechat1')" class="test1">分享小拉小程序</div>
    <div @click="initShare(1, 'wechat1', false)" class="test1">
      分享货运小程序
    </div>
    <div @click="initShare(2, 'wechat1')" class="test1">分享图片</div>
    <div @click="initShare(2, 'wechat1', true, true)" class="test1">
      分享图片base64
    </div>

    <h3>分享到朋友圈</h3>
    <div @click="initShare(0, 'wechatn')" class="test1">分享普通链接</div>
    <div @click="initShare(1, 'wechatn')" class="test1">
      分享小拉小程序
    </div>
    <div @click="initShare(1, 'wechatn', false)" class="test1">
      分享货运小程序
    </div>
    <div @click="initShare(2, 'wechatn', true, true)" class="test1">
      分享图片
    </div>
    <div @click="initShare(2, 'wechatn', true, true)" class="test1">
      分享图片base64
    </div>
    <h3>直接调用原生分享---->朋友圈</h3>
    <div
      @click="initShare1({ type: 0, to: 'wechatn', action: 'shareNew' })"
      class="test1"
    >
      分享普通链接
    </div>
    <div @click="initShare(1, 'wechatn', false)" class="test1">
      分享货运小程序
    </div>
    <div
      @click="
        initShare1({ type: 1, to: 'wechatn', action: 'shareNew', isXl: true })
      "
      class="test1"
    >
      分享小拉小程序
    </div>
    <div
      @click="initShare1({ type: 2, to: 'wechatn', action: 'shareNew' })"
      class="test1"
    >
      分享图片
    </div>
    <h3>直接调用原生分享---->微信好友</h3>

    <div
      @click="initShare1({ type: 0, to: 'wechat1', action: 'shareNew' })"
      class="test1"
    >
      分享普通链接
    </div>
    <div @click="initShare(1, 'wechat1', false)" class="test1">
      分享货运小程序
    </div>
    <div
      @click="
        initShare1({ type: 1, to: 'wechat1', action: 'shareNew', isXl: true })
      "
      class="test1"
    >
      分享小拉小程序
    </div>
    <div
      @click="initShare1({ type: 2, to: 'wechat1', action: 'shareNew' })"
      class="test1"
    >
      分享图片
    </div>
    <div @click="initShare2({ action: 'saveImg' })" class="test1">
      保存图片
    </div>
    <img src="" alt="" ref="testImg" hidden />
  </div>
</template>
<script>
import { callApp } from '@/utils';
export default {
  data() {
    return {
      link:
        'https://oimg-stg.huolala.cn/stone/stg/2021-05-26/673f41c8-2015-616b-87b2-c34e520c0a98.png',
      // https://oimg-stg.huolala.cn/stone/stg/2021-05-26/673f41c8-2015-616b-87b2-c34e520c0a98.png
      baseUrl: ''
    };
  },
  created() {
    this.getBase64Image(this.link);
  },
  methods: {
    //  第一个参数是图片的URL地址，第二个是转换成base64地址后要赋值给的img标签
    getBase64Image(url) {
      let that = this;
      let image = new Image();
      image.src = url + '?v=' + Math.random(); // 处理缓存
      image.crossOrigin = 'anonymous'; // 支持跨域图片
      image.onload = function() {
        let base64 = that.drawBase64Image(image);
        that.baseUrl = base64;
      };
    },
    drawBase64Image(img) {
      let canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, img.width, img.height);
      let dataURL = canvas.toDataURL('image/png');
      // console.log(dataURL, 'dataURL');
      return dataURL;
    },
    initShare(type, to, isXl = true, base64 = false) {
      console.log('baseUrl', base64);
      let link =
        'https://act2-stg.huolala.cn/page/202104/multi_service_invite/index.html?&code=byM7RNFb&bl=8&u=1&code=byM7RNFb';
      let img = base64 ? (this.baseUrl ? this.baseUrl : this.link) : this.link;
      // alert(img.slice(0, 20));
      // let img = this.link;
      let minGro = !isXl
        ? {}
        : {
            miniprogram_id: 'gh_53d3b8626252',
            miniprogram_path: `pages/index/index?webview=${encodeURIComponent(
              link
            )}`,
            miniprogram_type: 0
          };
      let args = {
        action: 'shareDirect',
        type, // 分享类型：0 普通链接、1 小程序、2 图片
        to: to, // 分享目标，多个目标用半角逗号分隔。目标枚举:wechat1-发送给微信朋友,wechatn-发送给微信朋友圈,qq1-发送给qq好友,qqn-发送给qq空间
        title: '【royi 专属】XL邀请活动模板-1.2.4 【', // 分享标题
        desc: '【royi 专属】XL邀请活动模板-1.2.4} desc', // 分享内容
        img, // 分享的图标url
        ...minGro,
        success: () => {
          console.log('分享成功');
        },
        error: () => {},
        link: link || location.href.split('#')[0] // 内容链接url
      };
      this.shareAct(args, to, 'shareDirect', true);
    },
    initShare1({ type, action, to, isXl = false }) {
      let link =
        'https://act2-stg.huolala.cn/page/202104/multi_service_invite/index.html?&code=byM7RNFb&bl=8&u=1&code=byM7RNFb';
      // let img = base64 ? this.link : this.baseUrl;
      let img = this.link;
      let minGro = !isXl
        ? {}
        : {
            miniprogram_id: 'gh_53d3b8626252',
            miniprogram_path: `pages/index/index?webview=${encodeURIComponent(
              link
            )}`,
            miniprogram_type: 0
          };
      let args = {
        action,
        type, // 分享类型：0 普通链接、1 小程序、2 图片
        to: to, // 分享目标，多个目标用半角逗号分隔。目标枚举:wechat1-发送给微信朋友,wechatn-发送给微信朋友圈,qq1-发送给qq好友,qqn-发送给qq空间
        title: '【royi 专属】XL邀请活动模板-1.2.4 【', // 分享标题
        desc: '【royi 专属】XL邀请活动模板-1.2.4} desc', // 分享内容
        img, // 分享的图标url
        ...minGro,
        success: () => {
          console.log('分享成功');
        },
        error: () => {},
        link: link || location.href.split('#')[0] // 内容链接url
      };
      this.shareAct(args, to, 'shareDirect', true);
    },
    initShare2({ action }) {
      let imgKey = 'content';
      window.savedCallback = () => {
        // this.$hll.toast('保存成功，已保存至手机相册');
      };
      console.log(this.baseUrl);
      callApp(
        JSON.stringify({
          action,
          [imgKey]: this.baseUrl,
          callback: 'savedCallback'
        })
      );
    }
  }
};
</script>
<style lang="less" scoped>
.test1 {
  margin: 40px auto;
  background-color: red;
  color: #fff;
  .fc;
  padding: 20px 60px;
  border-radius: 30px;
}
</style>
